<template>
  <div id="step-3-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step3Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt:
            'Getting pre-qualified for a mortgage is the same as getting pre-approved for a mortgage.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 1,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "Getting pre-qualified provides you with an idea of how much you may borrow but is not a commitment from the lender. With a pre-approval, the lender informs you as to whether you've been approved for a specific loan amount, which in essence is a stronger commitment from the lender.",
        },
        {
          prompt: 'What should you consider before deciding on a lender?',
          type: 'singleChoice',
          options: [
            'Loan options available',
            'Closing costs and other fees',
            'Quality of customer service',
            'All the above',
          ],
          correctAnswer: 3,
          bottomHeaderTrue: 'Correct!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'The different types of loan options a lender offers, their closing costs and other fees, and quality of their customer service are all things to consider when looking for a lender.',
        },
        {
          prompt:
            'The interest rate and the Annual Percentage Rate (APR) are the same thing.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 1,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "The interest rate is the actual rate of interest you're being charged, but the APR takes into account the fees you pay, showing you the actual cost of the credit. Because APR factors in the cost of the loan, it's good to compare APRs in addition to interest rates.",
        },
      ],
    };
  },
};
</script>

<style>
</style>
